import './TextFilter.css';

const LevelBadge = ({ requiredLevel, userLevel, isLoggedIn }) => {
  if (!isLoggedIn) {
    return <span className="level-badge login-required">Login Required</span>;
  }
  if (userLevel < requiredLevel) {
    return <span className="level-badge">Level {requiredLevel}+</span>;
  }
  return null;
};

const TextFilter = ({ 
  label, 
  placeholder, 
  value, 
  onChange, 
  onKeyDown,
  minLength = 1,
  showHelperText = true,
  disabled = false,
  requiredLevel,
  userLevel,
  isLoggedIn
}) => {
  return (
    <div className="filter-group">
      <label>
        <span>{label}</span>
        {requiredLevel !== undefined && (
          <LevelBadge requiredLevel={requiredLevel} userLevel={userLevel} isLoggedIn={isLoggedIn} />
        )}
      </label>
      <input
        type="text"
        placeholder={placeholder}
        value={value}
        onChange={onChange}
        onKeyDown={onKeyDown}
        disabled={disabled}
      />
      {showHelperText && minLength > 1 && (
        <small className="filter-helper-text">
          Min {minLength} chars. Use comma for multiple terms (AND search)
        </small>
      )}
    </div>
  );
};

export default TextFilter;
